import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Ortak } from './../../providers/ortak';
import { BllOrtak } from './../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the DepoCikisIslemiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 
@Component({
  selector: 'page-depo-cikis-islemi',
  templateUrl: 'depo-cikis-islemi.html',
})
export class DepoCikisIslemiPage {

  cari: any = { ID: -1, Definition_: "", CariKartID: "", };
  StokHareket = { ID: -1, StokKartID:1,IslemTuru: 5, Sign: 0, CardRef: 1,SlsMan:"",Tutar: "",Text:"", AciklamaRef: 1 ,Kg:1};
  CariHareket = { ID: -1, CariKartID: "", IslemTuru: 3, Sign: 1,Tutar: "",SlsMan:"",Text:"Mobilden Yapılan Ödeme"}
  vwCari: any = {};
  aranan="";
  yaziciadi: any;
  fisNumarasi: any;
  fisyaziciadi: any;
  evethayir = [];
  PalsanFiyat:number=0;
  DepoFiyat:number=0;
  IlacFiyat:number=0;
  skip:number=0;
  take:number=50;
  stokListesi=[];
  fisyazicioto:number=0;
  aktifKullanici:any;
  constructor(public navCtrl: NavController,
 
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public viewCtrl:ViewController,
    public navParams: NavParams) {
      this.evethayir = [{
        "ID": "0",
        "Adi": "Hayır"
      },
      {
        "ID": "1",
        "Adi": "Evet"
      }
      ];
      if (navParams.get("vwCari") != null) {
        this.vwCari = navParams.get("vwCari");
        var data = new FormData();
        data.append("cari_id", this.vwCari.ID);
  
        this.bllOrtak.islem(data, "CariGetirByID", "", false).then(a => {
          var Sonuc = <any>a;
          this.cari = Sonuc.SonucObject;
          this.StokHareket.CardRef = this.cari.ID;
          this.CariHareket.CariKartID = this.cari.ID;
          this.yaziciadi = "";
          this.fisyaziciadi = "";
        }
        )
      }
      this.fisyazicioto=1;
      this.aktifKullanici = this.ortak.storagePersonelGetir.Name
  }

  
  ionViewDidLoad() {
    this.stokGetir();
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  boslukKontrol() {
    var mesaj = "";
    if (this.StokHareket.Tutar == null || this.StokHareket.Tutar == "") {
      mesaj = mesaj + "Lütfen cari adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();
   
    this.CariHareket.Tutar = this.StokHareket.Tutar;
    this.CariHareket.Text = this.StokHareket.Text;
    this.CariHareket.SlsMan=this.aktifKullanici;
    this.StokHareket.SlsMan=this.aktifKullanici;

    formData.append("CariTah_json", JSON.stringify(this.CariHareket));
    formData.append("StokHareket_json", JSON.stringify(this.StokHareket));
    formData.append("yaziciadi", "");
    formData.append("palsan", this.PalsanFiyat.toString());
    formData.append("depo", this.DepoFiyat.toString());
    formData.append("Makbuz", this.fisNumarasi);
    formData.append("ilac", this.IlacFiyat.toString());
    formData.append("fisyaziciadi", "");
 formData.append("yazdiracakmiyiz","0");


    this.bllOrtak.islem(formData, "StokHareketCikisEkle", "", false).then(a => {
      // var sonuc = <any>a;
      // if (sonuc.Sonuc == 1) 
        this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");   this.viewCtrl.dismiss();
 
      // console.log("snc",sonuc.SonucObject);
      // if(sonuc.Sonuc==99) console.log(sonuc.Exception);
      

    })


  }
  stokGetir(){
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
 
    this.bllOrtak.islem(formData, "Stoklar", "", false).then(a => {
     
      var sonuc = <any>a;
      this.stokListesi = sonuc.SonucObject;
      
  console.log("stoklar",this.stokListesi);
  
    })
  }
  
  }






// WEBPACK FOOTER //
// ./src/pages/depo-cikis-islemi/depo-cikis-islemi.ts